import { memo } from 'react'

import { RenderWhen } from 'cng-common/components/renderWhen'
import { Translation } from 'cng-common/features/translations'

import { ReassignmentItem } from '../../model/types'

import styles from './ReassignedItem.module.scss'

type Props = {
  title: string
  items: ReassignmentItem[]
}

export const ReassignedItem = memo<Props>(({ title, items }) => {
  return (
    <div className={styles.block}>
      <h6>
        <Translation text={title} span />
      </h6>
      {items.map((item) => (
        <div key={item.key} className={styles.item} data-non-assigned={!item.contact}>
          <span className={styles.displayName}>
            <strong>{item.displayName}</strong> to
          </span>
          <RenderWhen condition={!item.contact}>
            <span className={styles.contact}>
              <em>Unassigned</em>
            </span>
          </RenderWhen>
          <RenderWhen condition={!!item.contact}>
            <span className={styles.contact}>
              <span
                className={styles.contactName}
              >{`${item.contact?.firstName} ${item.contact?.lastName}`}</span>
              <span className={styles.contactEmail}>{item.contact?.email}</span>
            </span>
          </RenderWhen>
        </div>
      ))}
    </div>
  )
})

ReassignedItem.displayName = 'ReassignedItem'
